import React from 'react';
import Link from 'next/link';
import { useTranslation } from '../../hooks/useTranslation';
import Price from '../ui/Price';
import ProductAction from './ProductAction';
import ProductVariants from './ProductVariants';
import ProductFulfilment from './ProductFulfilment';
import DropRegistration from '../drop/DropRegistration';
import { singleCardUrl } from '../../utils/slugify';

export default function ProductPurchase({ product, shipping, purchase, drop, type = 'product' }) {
  const { t, locale } = useTranslation('product');
  const { displayedPrice, oldPrice, percentDiscount, isSpecial, tierCap, inCart, mode } = purchase;
  const returnTo = `${locale === 'en' ? '/en' : ''}${type === 'single' ? singleCardUrl(product) : `/produs/${product.slug}`}#product-purchase`;

  return <section aria-label={t('purchase.title')} id="product-purchase" className="flex w-full max-w-[420px] scroll-mt-24 flex-col text-krit-ink">
    {product.variants?.length > 0 && <div className="order-2 mt-4 sm:order-none sm:mt-0"><ProductVariants variants={product.variants} /></div>}
    <div className={`grid gap-3 sm:gap-5 ${mode === 'drop' ? 'mb-3 sm:mb-5' : ''}`}>
      <div className="min-w-0">
        <p className="mb-1 text-[10px] font-bold uppercase tracking-[0.15em] text-krit-muted sm:mb-2">{t(isSpecial ? 'purchase.specialPrice' : 'purchase.price')}</p>
        <div className="flex flex-wrap items-baseline gap-x-3 gap-y-2">
          <Price amount={displayedPrice} discounted={oldPrice != null} className="text-[32px] font-black leading-none tracking-tight sm:text-4xl [&_sup]:text-base [&_sup]:font-semibold" />
          {oldPrice != null && <del className="text-base text-krit-muted"><Price amount={oldPrice} tone="muted" /></del>}
          {oldPrice != null && percentDiscount > 0 && <span className="rounded-md bg-krit-ink px-2 py-1 text-xs font-bold text-krit-yellow">−{percentDiscount}%</span>}
        </div>
        {isSpecial && tierCap != null && <p className="mt-2 hidden text-xs font-semibold text-krit-surface sm:block">{t('purchase.tierLimit').replace('{count}', tierCap)}</p>}
      </div>
      {mode !== 'drop' && <div className="min-w-0"><ProductAction product={product} purchase={purchase} type={type} returnTo={returnTo} big /></div>}
      {inCart > 0 && <div className="flex flex-wrap items-center justify-between gap-2 text-xs">
        <span role="status">{t('purchase.inCart').replace('{count}', inCart)}</span>
        <Link href="/cos" className="font-bold underline underline-offset-4">{t('purchase.viewCart')} →</Link>
      </div>}
    </div>
    {mode === 'drop' && <DropRegistration key={product.activeDrop?.code || 'closed'} code={product.activeDrop?.code} drop={drop} returnTo={returnTo} showDetails />}
    {mode !== 'drop' && <div className="order-3"><ProductFulfilment product={product} shipping={shipping} purchase={purchase} type={type} /></div>}
  </section>;
}
